import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import React, { FC } from 'react';
import { CircularProgress, CircularProgressProps } from '@material-ui/core';

// eslint-disable-next-line
interface LoaderProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    color?: CircularProgressProps['color'];
}

const getDimension = (size: LoaderProps['size'] = 'md'): number => {
    switch (size) {
        case 'xs': return 24;
        case 'sm': return 32;
        case 'md': return 40;
        case 'lg': return 48;
        case 'xl': return 56;
        default: return 40;
    }
}

const Loader: FC<LoaderProps> = (props) => {

    const classes = useStyles();
    const { size = 'md', color = 'primary' } = props;

    const dim = getDimension(size);

    return (
        <div className={classes.root} >
            <CircularProgress color={color} size={dim} />
        </div>
    )
}

const useStyles = makeStyles(((theme: Theme) => createStyles({
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        flex: 1,
        height: '100%'
    },
    md: {

    }
})))

export default Loader;